import _classCallCheck from '/app/node_modules/babel-runtime/helpers/classCallCheck';
import _createClass from '/app/node_modules/babel-runtime/helpers/createClass';
export var DashboardApi = function () {
    function DashboardApi(axios) {
        _classCallCheck(this, DashboardApi);

        this.axios = axios;
    }

    _createClass(DashboardApi, [{
        key: 'getGraphicAdmin',
        value: function getGraphicAdmin(data) {
            return this.axios.$post('/dashboard/dashboard/get-graphic-admin-boss', data);
        }
    }, {
        key: 'getGraphicSupervisor',
        value: function getGraphicSupervisor(data) {
            return this.axios.$post('/dashboard/dashboard/get-graphic-supervisor', data);
        }
    }, {
        key: 'getGraphicSeller',
        value: function getGraphicSeller(data) {
            return this.axios.$post('/dashboard/dashboard/get-graphic-seller', data);
        }
    }, {
        key: 'findAffiliationProcess',
        value: function findAffiliationProcess(data) {
            return this.axios.$post('/affiliation/affiliation/find-AffiliationProcess', data);
        }
    }, {
        key: 'getTableProcessAdmin',
        value: function getTableProcessAdmin(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-process-admin-boss', data);
        }
    }, {
        key: 'getTableProcessSupervisor',
        value: function getTableProcessSupervisor(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-process-supervisor', data);
        }
    }, {
        key: 'getTableProcessSeller',
        value: function getTableProcessSeller(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-process-seller', data);
        }
    }, {
        key: 'getTableRanking',
        value: function getTableRanking(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-ranking', data);
        }
    }, {
        key: 'getTableWorkAdmin',
        value: function getTableWorkAdmin(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-work-admin-boss', data);
        }
    }, {
        key: 'getTableWorkSupervisor',
        value: function getTableWorkSupervisor(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-work-supervisor', data);
        }
    }, {
        key: 'getTableWorkSeller',
        value: function getTableWorkSeller(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-work-seller', data);
        }

        //Export Table

    }, {
        key: 'getTablePendingExportAdminBoss',
        value: function getTablePendingExportAdminBoss(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-pending-export-admin-boss', data);
        }
    }, {
        key: 'getTableProcessExportAdminBoss',
        value: function getTableProcessExportAdminBoss(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-process-export-admin-boss', data);
        }
    }, {
        key: 'getTableProcessExportSupervisor',
        value: function getTableProcessExportSupervisor(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-process-export-supervisor', data);
        }
    }, {
        key: 'getTableProcessExportSeller',
        value: function getTableProcessExportSeller(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-process-export-seller', data);
        }
    }, {
        key: 'getTableWorkExportAdminBoss',
        value: function getTableWorkExportAdminBoss(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-work-export-admin-boss', data);
        }
    }, {
        key: 'getTableWorkExportSupervisor',
        value: function getTableWorkExportSupervisor(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-work-export-supervisor', data);
        }
    }, {
        key: 'getTableWorkExportSeller',
        value: function getTableWorkExportSeller(data) {
            return this.axios.$post('/dashboard/dashboard/get-table-work-export-seller', data);
        }
    }]);

    return DashboardApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/dashboard.js
// module id = ./src/api/dashboard.js
// module chunks = 34